import {createContext, useCallback, useContext, useEffect, useState,} from "react";
import {jwtDecode} from "jwt-decode";
const PatAuthContext = createContext();
export default PatAuthContext;
export const PatAuthProvider = ({children}) => {
    //----------------------------------------------------
    // TOKENS
    //----------------------------------------------------
    const [authTokens, setAuthTokens] = useState(() => {
        const stored = localStorage.getItem("patAuthTokens");
        return stored ? JSON.parse(stored) : null;
    });
    //----------------------------------------------------
    // PATIENT
    //----------------------------------------------------
    const [patient, setPatient] = useState(() => {
        const stored = localStorage.getItem("patAuthTokens");
        if (!stored) return null;
        try {
            return jwtDecode(JSON.parse(stored).access);
        } catch {
            return null;
        }
    });
    //----------------------------------------------------
    const [loading, setLoading] = useState(true);
    //----------------------------------------------------
    // LOGIN
    //----------------------------------------------------
    const loginPatient = async (e) => {
        e.preventDefault();
        let response = await fetch(`${window.location.origin}/api/patient/token/`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    hospital_code: e.target.hospital_code.value,
                    username: e.target.username.value,
                    password: e.target.password.value,
                }),
            }
        );
        let data = await response.json();
        if (response.status === 200) {
            const decoded = jwtDecode(data.access);
            setAuthTokens(data);
            setPatient(decoded);
            //------------------------------------------------
            localStorage.setItem(
                "patAuthTokens",
                JSON.stringify(data)
            );
            localStorage.setItem(
                "pat_login",
                "true"
            );
            localStorage.setItem(
                "patient_id",
                decoded.patient_id
            );
            localStorage.setItem(
                "pat_id",
                decoded.pat_id
            );
            localStorage.setItem(
                "role",
                decoded.role
            );
            localStorage.setItem(
                "tenant",
                decoded.tenant
            );
            localStorage.setItem(
                "hospital_code",
                e.target.hospital_code.value
            );
            //------------------------------------------------
            window.location.href = "/pat-menu/";
        } else {
            alert("Invalid Patient ID or Password");
        }
    };
    //----------------------------------------------------
    // LOGOUT
    //----------------------------------------------------
    const logoutPatient = () => {
        setAuthTokens(null);
        setPatient(null);
        localStorage.removeItem("patAuthTokens");
        localStorage.removeItem("pat_login");
        localStorage.removeItem("patient_id");
        localStorage.removeItem("pat_id");
        localStorage.removeItem("role");
        localStorage.removeItem("tenant");
        localStorage.removeItem("hospital_code");
        window.location.href = "/patient-login";
    };
    //----------------------------------------------------
    // REFRESH TOKEN
    //----------------------------------------------------
    const updateToken = useCallback(async () => {
        if (!authTokens?.refresh) {
            if (loading)
                setLoading(false);
            return;
        }
        try {
            let response = await fetch(`${window.location.origin}/api/token/refresh/`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        refresh: authTokens.refresh,
                    }),
                }
            );
            let data = await response.json();
            if (response.status === 200) {
                const decoded = jwtDecode(data.access);
                setAuthTokens(data);
                setPatient(decoded);
                localStorage.setItem(
                    "patAuthTokens",
                    JSON.stringify(data)
                );
                localStorage.setItem(
                    "patient_id",
                    decoded.patient_id
                );
                localStorage.setItem(
                    "pat_id",
                    decoded.pat_id
                );
                localStorage.setItem(
                    "role",
                    decoded.role
                );
                if (decoded.tenant) {
                    localStorage.setItem(
                        "tenant",
                        decoded.tenant
                    );
                }
            } else {
                logoutPatient();
            }
        } catch {
            logoutPatient();
        }
        if (loading)
            setLoading(false);
    }, [authTokens, loading]);
    //----------------------------------------------------
    useEffect(() => {
        if (loading && authTokens?.refresh) {
            updateToken();
        } else if (loading) {
            setLoading(false);
        }
        let interval;
        if (authTokens) {
            interval = setInterval(() => {
                updateToken();
            }, 1000 * 60 * 4);
        }
        return () => clearInterval(interval);
    }, [authTokens, loading, updateToken]);
    //----------------------------------------------------
    const contextData = {
        patient,
        authTokens,
        loginPatient,
        logoutPatient,
    };
    //----------------------------------------------------
    return (
        <PatAuthContext.Provider value={contextData}>
            {loading ? null : children}
        </PatAuthContext.Provider>
    );
};
export const usePatAuth = () => {
    return useContext(PatAuthContext);
};